// extracted by mini-css-extract-plugin
module.exports = {"planning":"Planning_planning__9r45F","desktop":"Planning_desktop__3-EJ_"};